import { render, staticRenderFns } from "./znhjjk.vue?vue&type=template&id=47a43c3c&scoped=true"
import script from "./znhjjk.vue?vue&type=script&lang=js"
export * from "./znhjjk.vue?vue&type=script&lang=js"
import style0 from "./znhjjk.vue?vue&type=style&index=0&id=47a43c3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a43c3c",
  null
  
)

export default component.exports